import axios from "axios";
import { URL_BASE } from "../config/url-server";


const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")






export const firstApplicationByLot = async (startDate, endDate,farmId,lotId,sectionId,lots,type) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,type };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/first-applications-by-lot",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};





export const firstApplicationByDay = async (startDate, endDate,farmId,lotId,sectionId,lots,type) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,type };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/first-application-by-day",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const palmWithApplications = async (startDate, endDate,farmId,lotId,sectionId,lots) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/palm-with-applications",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const palmWithApplicationsMonth = async (startDate, endDate,farmId,lotId,sectionId,lots) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/palm-with-applications-month",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const firstApplicationHectareMonth = async (startDate, endDate,farmId,lotId,sectionId,lots,type) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,type };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/first-application-hectare-month",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const firstApplicationHectareLot = async (startDate, endDate,farmId,lotId,sectionId,lots,type) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,type };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/first-application-hectare-lot",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const hectaresApplications = async (startDate, endDate,farmId,lotId,sectionId,lots) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/hectares-application",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const hectaresApplicationsByUser = async (startDate, endDate,farmId,lotId,sectionId,lots) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/hectares-application-by-user",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const getApplicationsByLot = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/applications-by-lot",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const getTotalApplicationsByUser = async (startDate, endDate,farmId,lotId,sectionId,lots) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/total-applications-by-user",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};






export const getTotalApplicationsByType = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/total-applications-by-type",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




/////////LO VIEJO DE ACA PA ABAJO//////////

export const averageHectares = async (startDate, endDate,farmId,lotId,sectionId,lots) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/average-hectares",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const hectaresByDay = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/hectares-by-day",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const averageByPalm = async (startDate, endDate,farmId,lotId,sectionId,lots,type) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,type};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/average-by-palm",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const averageByPalmMonth = async (startDate, endDate,farmId,lotId,sectionId,lots,type) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,type};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/average-by-palm-month",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const averageByUser = async (startDate, endDate,farmId,lotId,sectionId,lots) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/average-by-user",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const applicationsByDay = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/applications-by-day",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const getTotalApplicationsByHour = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId};
  console.log("OJO LA HORA EN EL DASHBOARD:",startDate)
  console.log("OJO LA HORA EN EL DASHBOARD:",endDate)
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/total-applications-by-hour",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const firstApplicationMonth = async (startDate, endDate,farmId,lotId,sectionId,lots,type) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,type };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/first-application-month",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const cyclesBySectionMonth = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/cycles-by-section-month",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const cyclesByFarmMonth = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/cycles-by-farm-month",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const cyclesByLotMonth = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/cycles-by-lot-month",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const cyclesByPalm = async (params) => {
  //const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/cycles-by-palm",
      config
    );
    const listado = response?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const getIndicatorValues = async (startDate, endDate,farmId, lotId, sectionId, lots) => {
  const params = {startDate, endDate,farmId,lotId,sectionId,lots };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/indicator-values",
      config
    );
    const listado = response?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const firstApplicationYear = async (params) => {  
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/first-application-by-year",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const getRainFallProduction = async (params) => {  
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/rainfall-production",
      config
    );
    const listado = response?.data|| null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export default {
  getTotalApplicationsByType,
  getTotalApplicationsByUser,
  getApplicationsByLot,
  averageByUser,
  applicationsByDay,
  averageByPalm,
  averageByPalmMonth,
  hectaresByDay,
  averageHectares,
  hectaresApplicationsByUser,
  hectaresApplications,
  firstApplicationHectareLot,
  firstApplicationHectareMonth,
  palmWithApplications,
  firstApplicationByDay,
  getTotalApplicationsByHour,
  firstApplicationByLot,
  firstApplicationMonth,
  cyclesBySectionMonth,
  cyclesByFarmMonth,
  cyclesByLotMonth,
  cyclesByPalm,
  getIndicatorValues,
  palmWithApplicationsMonth,
  firstApplicationYear,
  getRainFallProduction
};
